export default __webpack_public_path__ + "static/media/admin.a93f612c.png";